import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MappingComponent} from '../../mapping/mapping.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'app-new-field',
    templateUrl: './new-field.component.html',
    styleUrls: ['./new-field.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NewFieldComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<MappingComponent>,
  public dialog: MatDialog,
  public translate: TranslateService) { 
    this.dialogRef.backdropClick().subscribe(() => {
      this.dialogRef.close({"option": "cancel"});
    });
  }

  ngOnInit(): void {
  }

  addField() {
    this.dialogRef.close({"option": "add"});
  }

  editField() {
    this.dialogRef.close({"option": "edit"});
  }

  redraw() {
    this.dialogRef.close({"option": "redraw"});
  }

}
